module.exports = __webpack_public_path__ + "static/media/tilde.a30de710.svg";